import { Component } from '@angular/core';
import { BasePage } from '../base.page';
import { Router } from '@angular/router';

@Component({
  selector: 'splash-page',
  templateUrl: 'splash.page.html',
  styleUrls: ['splash.page.scss']
})
export class SplashPage extends BasePage {
    constructor(
      public router: Router) {
        super(router)
    }

    usuario = ""
    senha = ""

    ngOnInit() {
      console.log("passou aqui ")
    }
}
